<template>
  <div>
    <span>Logging out . . .</span>
  </div>
</template>
<script>
import firebase from "../Firebase";

export default {
  name: "Signout",
  mounted() {
    firebase
      .auth()
      .signOut()
      .then(() => {
        this.$store.commit("resetDisplayName");
        this.$store.commit("resetEmail");
        this.$store.commit("resetUserId");
        this.$store.commit("resetPhotoUrl");
        this.$store.commit("resetPhNumber");
        this.$store.commit("resetAddress");
        this.$store.commit("resetCity");
        this.$store.commit("resetCountry");
        this.$store.commit("resetCurrency");
        this.$store.commit("resetCurrencySymbol");
        this.$store.commit("resetRfid");
        this.$store.commit("resetReferralUrl");
        this.$store.commit("resetPostalCode");
        this.$store.commit("resetShortList");
        this.$store.commit("resetShortListId");
        this.$store.commit("resetShortListDocId");
        localStorage.removeItem("saascadetechrfid");
        window.location.href = "/";
      });
  }
};
</script>
